import { Font } from '@utmb/design-system/text/font';
import { IconsEnum } from '@utmb/types/icons';
import React from 'react';
import { Icon } from '../icons/Icon';
import styles from './running-stones.module.scss';
import { ColorTypesEnum } from '@utmb/types/colors';
import { getColorStyle } from '@utmb/utils/colors';

interface RunningStonesProps {
    quantity?: number;
    size?: number;
    displayM?: boolean;
    color?: ColorTypesEnum.PRIMARY | ColorTypesEnum.SECONDARY;
}

const RunningStones = ({ quantity, size = 54, displayM = false, color = ColorTypesEnum.PRIMARY }: RunningStonesProps) => {
    let fontSize = size < 60 ? '16' : '25';
    if (typeof quantity === 'number' && !displayM) {
        if (quantity < 10) fontSize = size < 60 ? '20' : '35';
        else if (quantity < 100) fontSize = size < 60 ? '18' : '30';
    }
    return (
        <div className={styles.runningStoneContent}>
            <div className={styles.runningStoneBg}>
                <Icon color={color} variant={!quantity || quantity < 2 ? IconsEnum.RUNNING_STONE : IconsEnum.RUNNING_STONES} width={size} height={size} />
            </div>
            {typeof quantity === 'number' && !displayM ? (
                <Font.OxaniumRegular
                    color={getColorStyle(color === ColorTypesEnum.SECONDARY ? ColorTypesEnum.WS_PRIMARY : ColorTypesEnum.WS_SECONDARY)}
                    desktop={fontSize}
                    as="div"
                    className={styles.stonesQuantity}
                >
                    {quantity}
                </Font.OxaniumRegular>
            ) : (
                <Font.FuturaMedium
                    desktop={fontSize}
                    as="div"
                    className={styles.stonesQuantity}
                    color={getColorStyle(color === ColorTypesEnum.SECONDARY ? ColorTypesEnum.WS_PRIMARY : ColorTypesEnum.WS_SECONDARY)}
                >
                    M
                </Font.FuturaMedium>
            )}
        </div>
    );
};

export default RunningStones;
